// extracted by mini-css-extract-plugin
export default {"Notification":"Notification_Notification__2PRxq","Notification_entered":"Notification_Notification_entered__2Sw5E","Notification__close":"Notification_Notification__close__2Esyq"};